function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.325 27.534H.997v-27h20.328v27zM1.78 26.77h18.76V1.299H1.781v25.47z",
  fill: "#D60000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.874 10.18H3.349V2.832h7.525v7.35zm-6.742-.765h5.958V3.597H4.132v5.818z",
  fill: "#D60000"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.096 8.42V4.566H5.15V8.42h3.946zM18.895 11.737H3.349v.766h15.546v-.766zM18.895 14.136H3.349v.766h15.546v-.766zM18.895 16.56H3.349v.766h15.546v-.765zM18.895 2.831h-6.297v.766h6.297V2.83zM18.895 5.255h-6.297v.766h6.297v-.766zM18.895 18.96H3.349v.765h15.546v-.766zM18.895 24.344h-5.382v.766h5.382v-.766zM18.895 21.894h-5.382v1.583h5.382v-1.583zM31.201 11.38h-7.995v.766h7.995v-.766zM31.201 15.948h-7.995v.766h7.995v-.766z",
  fill: "#D60000"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.346 18.424a.399.399 0 01-.287-.102.364.364 0 010-.536l3.815-3.726-3.815-3.726a.364.364 0 010-.536.385.385 0 01.549 0l4.39 4.287-4.39 4.288a.67.67 0 01-.262.05z",
  fill: "#D60000"
});

function SvgInfoRed2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed2);
export default __webpack_public_path__ + "static/media/info-red2.6047834b.svg";
export { ForwardRef as ReactComponent };